import TopSection from "../components/topSection";
import BG from "../assets/about_bg.jpg";
import bawa_old from "../assets/bawa_old.jpeg";
import about_old from "../assets/about_old.jpeg";
import bawa_old_pic from "../assets/bawa_old_pic.jpeg";
import "../styles/aboutus.css";
import { useNavigate } from "react-router-dom";

function BevisBawa() {
  const navigate = useNavigate();
  return (
    <>
      <TopSection image={BG} text={"Bevis Bawa"}  backgroundPositionY={"43%"}  />
      <section className="light-bg py-5">
        <div className="visit-container container ">
          <div class="plan-section row m-0 px-0 py-5">
            <div class="plan-title col-3">
              Bevis Bawa: A Maverick Artist, Master Gardener, and Creator of
              Tropical Romance
            </div>
            <div class="plan-description row col-8">
              <div className="col-md-6">
                <p className="plain_text">
                  Brief is the home of late bevis bawa (1909–1992) in beruwala
                  sri lanka. Brief had been landscaped by the owner Bevis Bawa
                  over period of seven decades. It is now the home of the
                  landscape design practice Brief Garden Designs.
                </p>
                <p className="plain_text">
                  In 1929 Bawa was bequeathed the family rubber plantation by
                  his mother, Bertha Marianne née Schrader (1876–1946). The
                  original estate was approximately 81 hectares (200 acres) with
                  Bevis Bawa selling off portions of the estate to reduce it to
                  manageable proportions & with that money he travelled the
                  world over.
                </p>
                <p className="plain_text">
                  He was influenced by his travels to build this wonderful,
                  garden, which was opened to the public in 1969. Eversince it
                  has been visited by many foreign
                </p>
              </div>

              <div className="col-md-6">
                <p className="plain_text">
                  and local tourists & students from around the world including
                  celebrities such as Vivien Leigh, Peter finch, Sir Laurence
                  Olivier and the royalty such as Queen Ingrid, (The Late Queen
                  Mother of Denmark). Brief was the home, to many local &
                  foreign Artists such as Donald Friend, Barbara Sansoni, Laki
                  Senanayake, and visited by many local & foreign artists like
                  Russel Drysdale. Bevis continued to work on the garden until
                  he lost his sight in late 1980’s. Bevis passed away in 1992.
                </p>
                <p className="plain_text">
                  The estate was inherited by Dooland de Silva, which was passed
                  on to his son Dan de Silva in 2022.
                </p>
                <p className="plain_text">
                  Brief was identified and featured on “THE GREAT GARDENS OF THE
                  WORLD” since 2019.
                </p>
              </div>
            </div>
          </div>
          <div className="row py-5">
            <div className="col-3 ms-auto ">
              <div className="about_top_img_wrapper_b" style={{ backgroundImage: `url(${bawa_old})` }}>
              </div>
            </div>
            <div className="col-3 ">
              <div className="about_top_img_wrapper_b" style={{ backgroundImage: `url(${about_old})` }}>
              </div>
            </div>
            <div className="col-3 me-auto ">
              <div className="about_top_img_wrapper_b" style={{ backgroundImage: `url(${bawa_old_pic})` }}>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="dark-bg">
        <div className="container py-5">
          <div className="row mt-5">
            <div className="col-12 col-md-3 ps-1 me-auto">
              <p className="section-header light-text text-end">
                Bevis’s Living Canvas
              </p>
            </div>

            <div
              className="col-12 col-md-4   light-text  "
              style={{ textAlign: "justify" }}
            >
              <div>
                <p className="plain_text">
                  Bevis Bawa was not merely the creator of Brief Garden, he was
                  its soul. A towering presence in Sri Lanka’s cultural history,
                  Bevis was a self-taught landscape designer, artist, raconteur,
                  and aesthete whose life defied norms and whose vision helped
                  shape the artistic and horticultural identity of 20th century
                  Sri Lanka.
                </p>
                <p className="plain_text">
                  Born into a wealthy Anglo-Ceylonese family, Bevis was the
                  elder brother of the internationally acclaimed architect
                  Geoffrey Bawa. Where Geoffrey brought discipline and restraint
                  to design, Bevis embodied spontaneity, wit, and extravagance.
                  The contrast between the two was stark, but both played a
                  pivotal role in defining tropical modernism in their own
                  unique ways — Geoffrey through architecture, and Bevis through
                  landscape and garden art.
                </p>
              </div>
            </div>
            <div
              className="col-12 col-md-4  light-text  "
              style={{ textAlign: "justify" }}
            >
              <div>
                <p className="plain_text">
                  Bevis Bawa was not merely the creator of Brief Garden, he was
                  its soul. A towering presence in Sri Lanka’s cultural history,
                  Bevis was a self-taught landscape designer, artist, raconteur,
                  and aesthete whose life defied norms and whose vision helped
                  shape the artistic and horticultural identity of 20th century
                  Sri Lanka.
                </p>
                <p className="plain_text">
                  Born into a wealthy Anglo-Ceylonese family, Bevis was the
                  elder brother of the internationally acclaimed architect
                  Geoffrey Bawa. Where Geoffrey brought discipline and restraint
                  to design, Bevis embodied spontaneity, wit, and extravagance.
                  The contrast between the two was stark, but both played a
                  pivotal role in defining tropical modernism in their own
                  unique ways — Geoffrey through architecture, and Bevis through
                  landscape and garden art.
                </p>
              </div>
              <div className="d-flex px-3 justify-content-end align-items-end mt-5">
                <div style={{ height: "fit-content" }}>
                  {/* <button
                    className="btn-bawa primary-light-btn"
                    onClick={() => navigate("/bevis_bawa")}
                  >
                    see more
                  </button> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="light-bg py-5">
        <div className="visit-container container">
          <div class="plan-section row m-0 p-0">
            <div class="plan-title col-4">A Life of Living Art</div>
            <div class="plan-description row col-8">
              <div className="col-md-6">
                <p className="plain_text">
                  While not classically trained in any one discipline, Bevis was
                  an artist of life itself. His talents extended to mural
                  painting, furniture design, sculpture placement, and interior
                  styling all visible within his home at Brief. His personal
                  quarters are adorned with original paintings, eclectic
                  objects, colonial antiques, and oddities creating a living
                  collage of stories, ideas, and irreverent beauty.
                </p>
                <p className="plain_text">
                  The house itself, open to visitors today, offers an intimate
                  look into his world every room, every object reflects his
                  singular worldview: elegant but playful, colonial yet
                  tropical, grand but never pretentious.
                </p>
                <p className="plain_text">
                  Upon his death in 1992, Bevis entrusted Brief to Dooland de
                  Silva, his long-time secretary, companion, and creative
                  collaborator. Dooland, a landscape designer in his own right,
                  has carefully preserved and nurtured Bevis’s vision while
                  opening
                </p>
              </div>

              <div className="col-md-6">
                <p className="plain_text">
                  the garden to the world. Today, under Brief Garden (Pvt) Ltd,
                  the estate functions both as a living museum and a working
                  design studio, with Dooland & Dan continuing the landscape
                  design legacy Bevis pioneered.
                </p>
                <p className="plain_text">
                  Brief remains one of Sri Lanka’s most visited and revered
                  private gardens, a living tribute to a man who chose to make
                  art with the land, and live life entirely on his own terms.
                </p>
                <p className="plain_text">
                  Bevis Bawa didn’t chase recognition. He left behind no
                  manifestos, no formal training manuals, no awards just a
                  garden, a home, and a story. And yet, his influence continues
                  to ripple through Sri Lanka’s artistic consciousness. He
                  showed that design could be sensual, that nature could be
                  theatrical, and that beauty could exist purely for its own
                  sake.
                </p>
              </div>
            </div>
            <div className="col-8 m-auto py-5">
              <p className="quot_text">
                To visit Brief Garden is to walk through the imagination of
                Bevis Bawa a place where the lines between art, life, and
                landscape blur, and the air is thick with charm, memory, and
                mischief.
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default BevisBawa;
